/* ---------- Galerij: vegen, pijltjes en thumbnails ---------- */
  (function(){
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs img'));
    var track = document.getElementById('gallery-track');

    /* Terugval: één losse hoofdfoto (geen slider) */
    if (!track) {
      var mainImg = document.getElementById('main-img');
      if (!mainImg) return;
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          thumbs.forEach(function(x){ x.classList.remove('active'); });
          t.classList.add('active');
          if (t.dataset.full) mainImg.src = t.dataset.full;
        });
      });
      return;
    }

    var count = track.children.length;
    var current = 0;
    var settle;

    var colorName = document.getElementById('gallery-color-name');
    var counter = document.getElementById('gallery-count');

    function setActive(i){
      thumbs.forEach(function(t, n){ t.classList.toggle('active', n === i); });
      var img = track.children[i] && track.children[i].querySelector('img');
      if (colorName && img) colorName.textContent = img.alt;
      if (counter) counter.textContent = (i + 1) + ' / ' + count;
      /* thumbnailbalk meeschuiven (mobiel), zonder de pagina te laten scrollen */
      var t = thumbs[i];
      if (t) {
        var bar = t.parentElement;
        if (bar.scrollWidth > bar.clientWidth) {
          bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    function goTo(i){
      var wrapped = i < 0 || i >= count;
      current = (i + count) % count;
      track.scrollTo({ left: current * track.clientWidth, behavior: wrapped ? 'auto' : 'smooth' });
      setActive(current);
    }

    thumbs.forEach(function(t, n){
      t.addEventListener('click', function(){ goTo(n); });
    });

    var prev = document.querySelector('.gallery-prev');
    var next = document.querySelector('.gallery-next');
    if (prev) prev.addEventListener('click', function(){ goTo(current - 1); });
    if (next) next.addEventListener('click', function(){ goTo(current + 1); });

    /* vegen gaat via native scroll-snap; pas na het stilvallen de actieve thumb bijwerken */
    track.addEventListener('scroll', function(){
      clearTimeout(settle);
      settle = setTimeout(function(){
        var pos = track.scrollLeft / track.clientWidth;
        /* alleen bijwerken als de foto echt op zijn plek staat, niet halverwege een animatie */
        if (Math.abs(pos - Math.round(pos)) > 0.02) return;
        var i = Math.round(pos);
        if (i !== current) { current = i; setActive(i); }
      }, 120);
    }, { passive: true });

    track.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    window.addEventListener('resize', function(){
      track.scrollTo({ left: current * track.clientWidth });
    });
  })();

  document.querySelectorAll('.tab-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.tab-btn').forEach(function(b){b.classList.remove('active');});
      document.querySelectorAll('.tab-panel').forEach(function(p){p.classList.remove('active');});
      btn.classList.add('active');
      document.getElementById('panel-' + btn.dataset.tab).classList.add('active');
    });
  });

  var bundleCards = document.querySelectorAll('.bundle-card');
  var giftCount = document.getElementById('gift-count');
  var gift1 = document.getElementById('gift-1');
  var gift2 = document.getElementById('gift-2');
  var mainCta = document.getElementById('main-cta');

  function selectBundle(card){
    bundleCards.forEach(function(c){c.classList.remove('selected');});
    card.classList.add('selected');
    var giftLevel = parseInt(card.dataset.gift, 10);
    var price = card.dataset.price;

    gift1.classList.toggle('unlocked', giftLevel >= 1);
    gift2.classList.toggle('unlocked', giftLevel >= 2);
    giftCount.textContent = giftLevel + '/2 cadeaus';

    mainCta.textContent = 'Ja, ik wil deze hoodie deken — €' + price;
  }

  bundleCards.forEach(function(card){
    card.addEventListener('click', function(){ selectBundle(card); });
  });

  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      q.parentElement.classList.toggle('open');
    });
  });

  (function(){
    var totalSeconds = 5*3600 + 59*60 + 42;
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if (!h || !m || !s) return;   /* geen teller op de pagina */
    setInterval(function(){
      if(totalSeconds > 0) totalSeconds--;
      var hh = Math.floor(totalSeconds/3600);
      var mm = Math.floor((totalSeconds%3600)/60);
      var ss = totalSeconds%60;
      h.textContent = String(hh).padStart(2,'0');
      m.textContent = String(mm).padStart(2,'0');
      s.textContent = String(ss).padStart(2,'0');
    }, 1000);
  })();

  /* ---------- Ervaringen: meer reviews uitklappen op mobiel ---------- */
  (function(){
    var grid = document.getElementById('mv-review-grid');
    var toggle = document.querySelector('.mv-review-toggle');
    if (!grid || !toggle) return;

    var label = toggle.querySelector('.mv-review-toggle-text');

    toggle.addEventListener('click', function(){
      var open = grid.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Minder reviews' : 'Meer reviews lezen';
    });
  })();

  /* ---------- Klantbeelden: pijltjes op mobiel ---------- */
  (function(){
    var scroller = document.querySelector('.proof-scroll');
    var prev = document.querySelector('.proof-prev');
    var next = document.querySelector('.proof-next');
    if (!scroller || !prev || !next) return;

    function step(){
      var card = scroller.querySelector('.proof-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 12;
      return card.offsetWidth + gap;
    }

    function update(){
      /* de carrousel klikt bij het laden vast op de eerste kaart (niet op 0),
         dus die positie telt als 'begin' */
      var first = scroller.querySelector('.proof-card');
      var start = first
        ? first.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft
        : 0;
      var max = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= start + 2;
      next.disabled = scroller.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function(){ scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function(){ scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();
